import { render, staticRenderFns } from "./NumberOrderList.vue?vue&type=template&id=3a1de084&scoped=true"
import script from "./NumberOrderList.vue?vue&type=script&lang=js"
export * from "./NumberOrderList.vue?vue&type=script&lang=js"
import style0 from "./NumberOrderList.vue?vue&type=style&index=0&id=3a1de084&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1de084",
  null
  
)

export default component.exports